import { PMREMGenerator } from "three";

// Three r146 substitutes the immersive camera in every render(), including
// PMREM's offscreen passes. Filter with XR disabled, then restore the session's
// render state. The resulting CubeUV texture bypasses automatic conversion.
export function withoutXrRendering(renderer, render) {
  const enabled = renderer.xr.enabled;
  const target = renderer.getRenderTarget();
  const face = renderer.getActiveCubeFace();
  const level = renderer.getActiveMipmapLevel();
  const autoClear = renderer.autoClear;
  try {
    renderer.xr.enabled = false;
    return render();
  } finally {
    renderer.setRenderTarget(target, face, level);
    renderer.autoClear = autoClear;
    renderer.xr.enabled = enabled;
  }
}

export function prefilterEnvironment(renderer, texture, Generator = PMREMGenerator) {
  return withoutXrRendering(renderer, () => {
    const generator = new Generator(renderer);
    try {
      return texture.isCubeTexture ? generator.fromCubemap(texture) : generator.fromEquirectangular(texture);
    } finally { generator.dispose(); }
  });
}
